import { PATH_UTILS } from 'services/_path';

export const servicesThatUsePathBffToGenerateLog = [
	{
		pathBff: `${PATH_UTILS}/integrador`,
		serviceBff: 'enderecos',
		serviceIntegrador: '/v2/enderecos',
	},
];
